var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wl-jm-print" },
    [
      _c(
        "wl-button",
        _vm._b(
          { attrs: { label: _vm.label }, on: { click: _vm.openPrintTemplate } },
          "wl-button",
          _vm.$attrs,
          false
        )
      ),
      _c(
        "wl-dialog-form",
        {
          attrs: {
            title: "选择打印模板",
            width: "360px",
            open: _vm.openDialog,
          },
          on: {
            "update:open": function ($event) {
              _vm.openDialog = $event
            },
            onOk: _vm.onJmPrint,
          },
        },
        [
          _c(
            "el-select",
            {
              style: { width: "100%" },
              attrs: { placeholder: "请选择打印模板", clearable: "" },
              model: {
                value: _vm.jmReportId,
                callback: function ($$v) {
                  _vm.jmReportId = $$v
                },
                expression: "jmReportId",
              },
            },
            _vm._l(_vm.printTemplateList, function (item, index) {
              return _c("el-option", {
                key: item.jmreportId,
                attrs: {
                  label: item.jmreportName,
                  value: item.jmreportId,
                  disabled: item.disabled,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }